import { $esputnikHttp } from '@/utils/https';

export const ecommerceAddToCartEvent = (payload) => {
  let { value, item_id, item_name, item_brand, item_category, item_variant, price, quantity, content_ids } = payload;
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'UAH',
      value: value || price,
      items: [
        {
          item_id,
          item_name,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          index: 0,
          item_brand,
          item_category,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          item_variant,
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price,
          quantity: quantity || 1
        }
      ]
    }
  });

  fbq('track', 'AddToCart', {
    content_type: 'product',
    currency: 'UAH',
    value: value || price,
    content_name: item_name,
    content_ids,
    content_category: item_category || item_brand || item_name
  });
};

export const ecommerceViewItemEvent = (payload) => {
  let { item_id, item_name, item_brand, item_category, item_variant, price } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: 'UAH',
      value: price,
      items: [
        {
          item_id,
          item_name,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          index: 0,
          item_brand,
          item_category,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          item_variant,
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price,
          quantity: 1
        }
      ]
    }
  });
};

export const ecommerceSelectItemEvent = (payload) => {
  let { item_id, item_name, item_brand, item_category, item_variant, price } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      item_list_id: 'Cosmetics',
      item_list_name: 'Cosmetics',
      items: [
        {
          item_id,
          item_name,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          index: 0,
          item_brand,
          item_category,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          item_variant,
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price,
          quantity: 1
        }
      ]
    }
  });
};

export const ecommerceViewCartEvent = (payload) => {
  let { value, items } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_cart',
    ecommerce: {
      currency: 'UAH',
      value,
      items: items.map((item, index) => {
        /**
         * @attrs {item_id, item_name, item_brand, item_category, item_variant, price, quantity} item
         */
        return {
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          index,
          ...item
        };
      })
    }
  });
};

export const ecommerceRemoveFromCartEvent = (payload) => {
  let { item_id, item_name, item_brand, item_category, price } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'UAH',
      value: price,
      items: [
        {
          item_id,
          item_name,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          index: 0,
          item_brand,
          item_category,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price,
          quantity: 1
        }
      ]
    }
  });
};

export const ecommerceViewItemListEvent = (payload) => {
  let { items } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item_list',

    ecommerce: {
      item_list_id: 'renew-cosmetics',
      item_list_name: 'Renew-Cosmetics',
      items: items.map((item, index) => {
        /**
         * @attrs {item_id, item_name, item_brand, item_category, item_variant, price} item
         */
        return {
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          index,
          quantity: 1,
          ...item
        };
      })
    }
  });
};

export const ecommerceBeginCheckoutEvent = (payload) => {
  let { value, items, num_items, content_ids, contents } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      currency: 'UAH',
      value,
      items: items.map((item, index) => {
        /**
         * @attrs {item_id, item_name, item_brand, item_category, item_variant, price, quantity} item
         */
        return {
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0.0,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          index,
          ...item
        };
      })
    }
  });

  fbq('track', 'InitiateCheckout', {
    value,
    currency: 'UAH',
    content_type: 'product',
    content_ids,
    contents,
    num_items
  });
};

export const ecommercePurchaseEvent = (payload) => {
  let { transaction_id, value, coupon, items, content_ids, contents, num_items } = payload;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id,
      value,
      tax: 0.0,
      shipping: 0.0,
      currency: 'UAH',
      coupon,
      items: items.map((item, index) => {
        /**
         * @attrs {item_id, item_name, item_brand, item_category, item_variant, price, quantity} item
         */
        let { item_id, item_name, item_brand, item_category, item_variant, price, quantity } = item;
        return {
          item_id,
          item_name,
          affiliation: 'Renew-Cosmetics',
          coupon: '',
          discount: 0,
          index,
          item_brand,
          item_category,
          item_list_id: 'Cosmetics',
          item_list_name: 'Cosmetics',
          item_variant,
          location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
          price,
          quantity
        };
      })
    }
  });

  fbq('track', 'Purchase', {
    value,
    currency: 'UAH',
    content_type: 'product',
    content_ids,
    contents,
    num_items
  });
};

export const esputnikAddToCart = (payload) => {
  payload = { ...payload, eventTypeKey: 'AddToCart' };
  $esputnikHttp.post('/event', payload).then((result) => {
    console.log('esputnikAddToCart', result);
  });
};

export const esputnikAddToCartShop = (payload) => {
  payload = { ...payload, eventTypeKey: 'AddToCartShop' };
  $esputnikHttp.post('/event', payload).then((result) => {
    console.log('esputnikAddToCartShop', result);
  });
};
